// import { Toast } from 'antd-mobile'
import config from '../config'
/* global FormData localStorage */

// const codeMessage = {
//   200: '服务器成功返回请求的数据。',
//   201: '新建或修改数据成功。',
//   202: '一个请求已经进入后台排队（异步任务）。',
//   204: '删除数据成功。',
//   400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
//   401: '用户没有权限（令牌、用户名、密码错误）。',
//   403: '用户得到授权，但是访问是被禁止的。',
//   404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
//   406: '请求的格式不可得。',
//   410: '请求的资源被永久删除，且不会再得到的。',
//   422: '当创建一个对象时，发生一个验证错误。',
//   500: '服务器发生错误，请检查服务器。',
//   502: '网关错误。',
//   503: '服务不可用，服务器暂时过载或维护。',
//   504: '网关超时。'
// }

/**
 *
 * @param {Response}
 * @returns {Response|undefined}
 */
async function checkStatus (response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  }
  if (response.status >= 400 && response.status < 600) {
    let errorText = ''
    let code = ''
    await response.json().then((res) => {
      errorText = res.message
      code = res.code
    })
    const error = new Error(errorText)
    error.name = response.status
    error.code = code || null
    error.response = response
    // if (code === '2000') {
    //   const hisCode = window.localStorage.getItem('sdxHisCode') ? window.localStorage.getItem('sdxHisCode') : ''
    //   const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId') ? `/${window.localStorage.getItem('sdxPatPositionId')}` : ''
    //   console.log(`${window.location.host}/#/index/${hisCode}${sdxPatPositionId}`)
    //   // window.location.replace(`${window.location.host}/#/index/${hisCode}${sdxPatPositionId}?code=90909`)
    // }
    // console.log(error)
    throw error
  }
  return response
}

/**
 * @returns {Promise<string|null>} authorization value
 */
async function getAuthorization () {
  const sdxUserToken = JSON.parse(localStorage.getItem('sdxUserToken'))
  if (!sdxUserToken) {
    return null
  }
  if (!sdxUserToken.access_token) {
    return null
  }
  if (!sdxUserToken.scope) {
    return null
  }
  if (!sdxUserToken.token_type) {
    return null
  }
  // if (Number(sdxUserToken.accessTokenExpire) > 0) {
  // return sdxUserToken.token_type + '46547685876ftdhfy6887ygy'
  return sdxUserToken.token_type + sdxUserToken.access_token
  // }
}

async function getUUID () {
  const sdxUUID = window.localStorage.getItem('sdxUUID')
  if (!sdxUUID) {
    return null
  }
  return sdxUUID
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default async function request (url, options) {
  try {
    const defaultOptions = {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit'
    }
    const newOptions = { ...defaultOptions, ...options }
    newOptions.method = newOptions.method.toUpperCase()
    const Authorization = await getAuthorization()
    if (Authorization) {
      if (!newOptions.headers) {
        newOptions.headers = {}
      }
      newOptions.headers.Authorization = Authorization
    }
    const UUID = await getUUID()
    if (UUID) {
      if (!newOptions.headers) {
        newOptions.headers = {}
      }
      // newOptions.headers.UUID = '0c02b74a915a46c387ed998aa59b58bb'
      newOptions.headers.UUID = UUID
      if (
        newOptions.method === 'POST' ||
      newOptions.method === 'PUT' ||
      newOptions.method === 'DELETE'
      ) {
        if (!(newOptions.body instanceof FormData)) {
          newOptions.headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            ...newOptions.headers
          }
          newOptions.body = JSON.stringify(newOptions.body)
        } else {
          // newOptions.body is FormData
          newOptions.headers = {
            Accept: 'application/json',
            ...newOptions.headers
          }
        }
      }

      url = config.server + url
      let res = await fetch(url, newOptions)
      // console.log(res)
      res = await checkStatus(res)
      const result = {}
      if (newOptions.method === 'DELETE' || res.status === 204) {
        result._raw = await res.text()
        result.data = result._raw
      }
      // result.headers = res.status
      result._raw = await res.json()
      result.data = result._raw.data || null
      result.message = result._raw.message || ''
      result.error = result._raw.error || null
      // if (result.error === 'invalid_token') {
      //   Toast.info('旧帐号已过期，请重新注册!')
      //   window.localStorage.removeItem('sdxUserToken')
      //   return result
      // }
      return result
    }
  } catch (e) {
    // const { dispatch } = store
    // const status = e.name
    // if (status === 401) {
    // //   dispatch({
    // //     type: 'login/logout'
    // //   })
    //   // return { error: e.message }
    //   return {
    //     data: null,
    //     error: e.message,
    //     status: e.name,
    //     response: e.response
    //   }
    // }
    // if (status === 403) {
    // //   dispatch(routerRedux.push('/exception/403'))
    //   // return { error: e.message }
    //   return {
    //     data: null,
    //     error: e.message,
    //     status: e.name,
    //     response: e.response
    //   }
    // }
    // if (status <= 504 && status >= 500) {
    // //   dispatch(routerRedux.push('/exception/500'))
    //   // return { error: e.message }
    //   return {
    //     data: null,
    //     error: e.message,
    //     status: e.name,
    //     response: e.response
    //   }
    // }
    // if (status >= 404 && status < 422) {
    // //   dispatch(routerRedux.push('/exception/404'))
    //   // return { error: e.message }
    //   return {
    //     data: null,
    //     error: e.message,
    //     status: e.name,
    //     response: e.response
    //   }
    // }
    // return { error: e.message }
    return {
      data: null,
      error: true,
      message: e.message,
      status: e.name,
      code: e.code,
      response: e.response
    }
  }
}
